import { render, staticRenderFns } from "./LinkOrText.vue?vue&type=template&id=7830f19d&scoped=true&"
import script from "./LinkOrText.vue?vue&type=script&lang=js&"
export * from "./LinkOrText.vue?vue&type=script&lang=js&"
import style0 from "./LinkOrText.vue?vue&type=style&index=0&id=7830f19d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7830f19d",
  null
  
)

export default component.exports